import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { VideoData } from './catalogue-video.model';

@Component({
  selector: 'app-catalogue-videos',
  templateUrl: './catalogue-videos.component.html',
  styleUrls: ['./catalogue-videos.component.scss'],
  providers: [CatalogService],
})
export class CatalogueVideosComponent implements OnInit {
  @Input() selectedTab : string;
  
  productVideoList = [];

  investorVideoList = [];

  activeVedioSection: string;

  activeVideoData: VideoData = new VideoData();

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  public readProductVideos() {
    this.catalogService.readProductVideos().subscribe(
      (response) => {
        this.productVideoList = [...response.data.videoList];
      },
      (error) => {}
    );
  }

  public readInvestorVideos() {
    this.catalogService.readInvestorVideos().subscribe(
      (response) => {
        this.investorVideoList = [...response.data.videoList];
      },
      (error) => {}
    );
  }

  public onSectionChange(section: string) {
    this.activeVedioSection = section;
    if (this.activeVedioSection === 'PRODUCT_VIDEO') {
      this.readProductVideos();
    } else {
      this.readInvestorVideos();
    }
  }

  public onEdit(data: VideoData) {
    this.activeVideoData = data;
  }

  public onRefreshData(section: string) {
    this.onSectionChange(section);
  }
}
